import { render } from "./Rates.vue?vue&type=template&id=436197d0"
import script from "./Rates.vue?vue&type=script&lang=js"
export * from "./Rates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__